import request from "../services/HTTPClient";
import { requestMethods, API } from "../constants";

function GetAll() {
  return request({
    url: API.MARKETING.GET_ALL,
    method: requestMethods.GET,
  });
}

function GetById(id) {
  return request({
    url: API.MARKETING.GET_BY_ID.concat(id),
    method: requestMethods.GET,
  });
}

function Add(data) {
  return request({
    url: API.MARKETING.ADD,
    method: requestMethods.POST,
    data: data
  });
}

function Update(id, data) {
  return request({
    url: API.MARKETING.UPDATE.concat(id),
    method: requestMethods.PUT,
    data: data
  });
}

function Delete(id) {
  return request({
    url: API.MARKETING.DELETE.concat(id),
    method: requestMethods.DELETE,
  });
}

const MarketingServices = {
  GetAll,
  GetById,
  Add,
  Update,
  Delete
};

export default MarketingServices;